import { useMemo } from 'react';
import { GameState } from '../../types/game';
import { calculatePotential } from '../../domain/potential';

export function useOptimizedPotential(gameState: GameState) {
  return useMemo(() => calculatePotential(gameState), [gameState]);
}

export type UseOptimizedPotentialReturn = ReturnType<typeof useOptimizedPotential>;
